import { createFileRoute } from '@tanstack/react-router';

import { BusinessDnaScreen } from '@/screens/onboarding/BusinessDnaScreen';

export const Route = createFileRoute('/_onboarding/onboarding/business-dna')({
  component: BusinessDnaScreen,
});
